import { useAmplitude } from 'hooks/useAmplitude';
import { useGlobals } from 'hooks/useGlobals';
import { usePayPerUseExtraTruckers } from 'hooks/usePayPerUseExtraTruckers';
import { ConsumptionType, SendUnlockSuggestedTruckersEventSource } from './types';

const useUnlockSuggestedTruckersEvents = () => {
  const globals = useGlobals();
  const { unlockedTruckersAmount, lockedTruckersAmount } = usePayPerUseExtraTruckers();

  const companyId = globals?.user?.data?.company?.id;
  const userId = globals?.user?.data?.id;

  const { sendAmplitude } = useAmplitude();

  const sendUnlockSuggestedTruckersEvent = (
    source: SendUnlockSuggestedTruckersEventSource,
    consumptionType?: ConsumptionType
  ) => {
    const commonProps = {
      source,
      companyId,
      userId,
      truckersNumbers: {
        unlocked: unlockedTruckersAmount,
        locked: lockedTruckersAmount,
        total: unlockedTruckersAmount + lockedTruckersAmount,
      },
    };

    const props = source === 'button-confirm' ? { ...commonProps, consumptionType } : commonProps;

    sendAmplitude('trucker_listing_unlock_suggested_list', { ...props });
  };

  return { sendUnlockSuggestedTruckersEvent };
};

export { useUnlockSuggestedTruckersEvents };
